// Import styles
import 'index.scss'

// Polyfill (needed for IE9 compatibility)
import 'babel-polyfill'

// Semantic JS
import 'semantic-ui-css/semantic'

// import React from 'react'
import _debug from 'debug'
import bindPlugins from './plugins'
import hookRouter from './router'
import { connectSSE } from './services/sse'

if (process.env.NODE_ENV !== 'production') {
  // Adding Perf addons in global scope
  global.Perf = require('react-addons-perf')

  // Enabling log
  _debug.enable('app::*')
}

const debug = _debug('app::boot')

debug('Liphatech Client')

debug('Binding SSE channel')
connectSSE()

debug('Enabling plugins')
bindPlugins()

debug('Hooking router')
hookRouter()



// WEBPACK FOOTER //
// ./src/index.js